/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { withMemo } from 'fierry/react.old';

import ResourceEnum from 'galax/enum/resource';

import Building from 'galax/react/map/entity/building';
import Resource from 'galax/react/map/entity/resource';
import SectorCenter from 'galax/react/map/entity/sector.center';
import Unit from 'galax/react/map/entity/unit';


const Component = (props) =>
{
  const { zone, currentUser } = props;

  if (zone.getCass().getResource() != null)
  {
    return <Resource {...props} />;
  }

  if (zone.getBuilding())
  {
    return <Building {...props} />;
  }

  if (zone.getUnit())
  {
    return <Unit {...props} />;
  }

  // TODO would be easier if sector could return Empty building (for currentUser only ?).
  if (zone.getCass().isCenter() && currentUser && zone.getUserID() === currentUser.getID() && !currentUser.isAncientUser())
  {
    return <SectorCenter {...props} />;
  }

  return null;
};


export default withMemo((props) =>
{
  const { zone } = props;

  return <Component {...props} location = {zone.getLocation()} />;
})
